module.exports = __webpack_public_path__ + "img/step-4-alt.cf459d4f.svg";